import { Action } from '@ngrx/store';
import { SelectionState } from '@alfresco/adf-extensions';

export enum SmtActionsTypes {
  SmtExcelExportAction = 'SMT_EXCEL_EXPORT_ACTION',
  SmtDownloadAllAction = 'SMT_DOWNLOAD_ALL_ACTION'
}

export class SmtExcelExportAction implements Action {
  readonly type = SmtActionsTypes.SmtExcelExportAction;

  /**
   * Constructor de la clase SmtExcelExportAction
   * @param selection - Parámetro opcional que permite seleccionar elementos antes de la exportación
   * @param totalItems - Número total de documentos que cumplen la búsqueda actual
   */
  constructor(public selection?: SelectionState, public totalItems?: number) {
  }
}

export class SmtDownloadAllAction implements Action {
  readonly type = SmtActionsTypes.SmtDownloadAllAction;
  /**
   * Constructor de la clase SmtDownloadAllAction
   * @param selection - Parámetro opcional que permite seleccionar elementos antes del descargo
   */
  constructor(public selection?: SelectionState) {}
}
